module.exports = "https://coinrabbit.io/_next/static/images/step-mobile-3-4b90e7b8849ad2668a2be11386bd22d2.svg";